import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import ReportDateSelector, { DateRangeOption } from './ReportDateSelector';

const FUNNEL_COLORS = ['#6366f1', '#818cf8', '#a5b4fc', '#10b981'];

const TrialFunnel: React.FC = () => {
  const [range, setRange] = useState<DateRangeOption>('30d');
  const [steps, setSteps] = useState<any[]>([]);

  useEffect(() => {
    let isMounted = true;
    const fetchFunnel = async () => {
      try {
        const res = await api.analytics.getTrialFunnel(range);
        if (isMounted && Array.isArray(res)) {
          setSteps(res);
        }
      } catch (err) {
        console.error('Failed to load trial funnel:', err);
      }
    };
    fetchFunnel();
    return () => { isMounted = false; };
  }, [range]);

  const maxVal = steps.length > 0 ? steps[0].count || 1 : 1;

  return (
    <div id="trial-funnel-report" className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm h-full">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h2 className="text-xl font-black text-slate-900 mb-1">Checkout &amp; Funnel</h2>
          <p className="text-sm text-slate-500">Live conversion flow from visitors to paid subscriptions.</p>
        </div>
        <ReportDateSelector value={range} onChange={setRange} />
      </div>
      <div className="space-y-4">
        {steps.map((step, idx) => {
          const pct = Math.max(12, Math.round((step.count / maxVal) * 100));
          const color = FUNNEL_COLORS[idx % FUNNEL_COLORS.length];
          const prevCount = idx > 0 ? steps[idx - 1].count : null;
          const convRate = prevCount && prevCount > 0 ? ((step.count / prevCount) * 100).toFixed(1) : null;

          return (
            <div key={step.stage || idx} className="relative">
              {convRate && (
                <div className="absolute -top-3 right-0 text-[10px] font-black text-emerald-600 uppercase bg-emerald-50 px-2 py-0.5 rounded">
                  {convRate}% Conv.
                </div>
              )}
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-bold text-slate-800">{step.stage}</span>
                <span className="text-sm font-black text-slate-900">{step.count.toLocaleString()}</span>
              </div>
              <div className="w-full bg-slate-100 h-6 rounded-xl overflow-hidden">
                <div 
                  className="h-full transition-all duration-500 rounded-xl" 
                  style={{ width: `${pct}%`, backgroundColor: color }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TrialFunnel;
